import { render, staticRenderFns } from "./index.vue?vue&type=template&id=82df2878&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=82df2878&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=82df2878&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82df2878",
  null
  
)

export default component.exports